export default {
  'day-first': 'DD/MM/YYYY',
  'month-first': 'MM/DD/YYYY',
  'year-first': 'YYYY/MM/DD'
};